import { get, remove, set } from "./Preferences";

const _requestedURLKey = "RequestedURL";

export const setRequestedURL = async (pathname: string) => {
    if (!!!pathname) {
        pathname = window.location.pathname;
    }
    if (pathname.includes("://")) {
        try {
            const urlObj = new URL(pathname);
            pathname = urlObj.pathname + (urlObj.search || "");
        } catch {
            // not a valid URL — use as-is
        }
    }
    if (!pathname.includes("/logout")) {
        await set(_requestedURLKey, pathname);
    }
};

export const getRequestedURL = async () => {
    //get stored URL
    let pathname = await get(_requestedURLKey);
    if (!!pathname) {
        //clear requested url
        remove(_requestedURLKey);

        return pathname;
    }
    return "/home";
};

const getRoutePath = (path: string) => {
    if (!!path) {
        const urlObj = new URL(path);
        return `${urlObj.pathname}/${urlObj.search}`;
    }
    return path;
};
